import React, { useState, useEffect } from "react";
import BASE_URL from "components/BaseUrl/apiConfig";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Tilt from "react-parallax-tilt";
import AnimatedCard from "react-animated-3d-card";
import CardStats from "components/Cards/CardStats.js";
import CardStats1 from "components/Cards/CardStats1.js";
import SummaryCard from "components/Cards/SummaryCard";
import QuantityImage from "assets/img/QuantityManagement.jpg";
import NotesImage from "assets/img/NotesManagement.jpg";
import DocumentImage from "assets/img/DocumentLibrarayManagement.jpg";
import MarketingImage from "assets/img/EmailMarketing.jpg";
import ExpenseImage from "assets/img/ExpensesManagement.jpg";

export default function HeaderStats() {
  const history = useHistory(); // Get the history object
  const [currency, setCurrency] = useState("");
  const [count, setCount] = useState("");
  const [totalBalance, setTotalBalance] = useState({});

  //get userid form loca storage
  const storedUserData = localStorage.getItem("userData");
  let userId = "";
  let groupId = "";
  let userTypeId = "";
  if (storedUserData) {
    const userData = JSON.parse(storedUserData);
    userId = userData.userId;
    groupId = userData.groupId;
    userTypeId = userData.userTypeId;
  }

  //Fetch all data in parallel
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [balanceResponse, currencyResponse, messageCountResponse] =
          await Promise.all([
            fetch(`${BASE_URL}/api/Expense/GetTotalBalance?groupId=${groupId}`),
            fetch(
              `${BASE_URL}/api/Users/GetCurrencyByUserId?groupId=${groupId}`
            ),
            fetch(
              `${BASE_URL}/api/Expense/MessageCountByGroupID?GroupID=${groupId}`
            ),
          ]);

        const balanceData = await balanceResponse.json();
        const currencyData = await currencyResponse.json();
        const messageCountData = await messageCountResponse.json();

        setTotalBalance(balanceData);
        setCurrency(currencyData.currency);
        setCount(messageCountData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [groupId]);

  // Check if availableBalance is greater than 0
  const isPositiveBalance = totalBalance.availableBalance > 0;

  // Set the color dynamically based on the condition
  const balanceColor = isPositiveBalance ? "rgb(0, 0, 255)" : "red";

  const OnQuantityTrackingClick = () => {
    history.push("/getQuantityTraking");
  };
  const OnMarketingClick = () => {
    history.push("/messageLogs");
  };

  const OnExpenseTrackingClick = () => {
    history.push("/expenses");
  };

  const OnNotesClick = () => {
    history.push("/notes");
  };

  const getDocument = () => {
    history.push("/getDocument");
  };

  //section permission
  const [mainUser, setMainUser] = React.useState([]);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await fetch(
          `${BASE_URL}/api/Users/GetUserById?userId=${userId}`
        );
        if (response.ok) {
          const data = await response.json();
          setMainUser(data);
        } else {
          console.error("Failed to fetch user data:", response.statusText);
        }
      } catch (error) {
        console.error("Error fetching user data:", error.message);
      }
    };
    fetchUserData();
  }, [userId]);

  // console.log(mainUser.chkDashboard);
  // console.log(mainUser.chkDocuments);
  // console.log(mainUser.chkExpense);
  // console.log(mainUser.chkMarketing);
  // console.log(mainUser.chkNotes);
  // console.log(mainUser.chkQuantityTracker);
  // console.log(mainUser.chkUsers);

  return (
    <>
      {/* Header */}

      <div className="relative HeaderStats">
        <div className="mx-auto w-full">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 m-3">
            {(mainUser.chkExpense || userTypeId === 2) && (
              <div className="text-center">
                <SummaryCard totalBalance={totalBalance} currency={currency} />
              </div>
            )}

            {(mainUser.chkQuantityTracker || userTypeId === 2) && (
              <div onClick={OnQuantityTrackingClick}>
                <Tilt scale={1.1} transitionSpeed={2500}>
                  <div className="bg-white shadow-lg p-3">
                    <div className="text-center">
                      <div className="text-center">
                        <span className="text-xl block">Quantity</span>
                        <span className="text-xl block">Management</span>
                      </div>
                    </div>
                    <img
                      src={QuantityImage}
                      alt="Quantity Tracking"
                      className="w-full h-auto object-cover"
                      style={{ paddingBottom: "20px" }}
                    />
                  </div>
                </Tilt>
              </div>
            )}

            {(mainUser.chkNotes || userTypeId === 2) && (
              <div onClick={OnNotesClick}>
                <Tilt scale={1.1} transitionSpeed={2500}>
                  <div className="bg-white shadow-lg p-3">
                    <div className="text-center">
                      <div className="text-center">
                        <span className="text-xl block">Notes</span>
                        <span className="text-xl block">Management</span>
                      </div>
                    </div>

                    <img
                      src={NotesImage}
                      alt="Notes Management"
                      className="w-full h-auto object-cover"
                      style={{ paddingBottom: "20px" }}
                    />
                  </div>
                </Tilt>
              </div>
            )}

            {(mainUser.chkDocuments || userTypeId === 2) && (
              <div onClick={getDocument}>
                <Tilt scale={1.1} transitionSpeed={2500}>
                  <div className="bg-white shadow-lg p-3">
                    <div className="text-center">
                      <span className="text-xl block">Documents</span>
                      <span className="text-xl block">Management</span>
                    </div>

                    <img
                      src={DocumentImage}
                      alt="Document Management"
                      className="w-full h-auto object-cover"
                      style={{ paddingBottom: "20px" }}
                    />
                  </div>
                </Tilt>
              </div>
            )}

            {(mainUser.chkMarketing || userTypeId === 2) && (
              <div onClick={OnMarketingClick}>
                <Tilt scale={1.1} transitionSpeed={2500}>
                  <div className="bg-white shadow-lg p-3">
                    <div className="text-center">
                      <span className="text-xl block">Marketing</span>
                      <span className="text-xl block">Management</span>
                    </div>

                    <img
                      src={MarketingImage}
                      alt="Marketing Management"
                      className="w-full h-auto object-cover"
                      style={{ paddingBottom: "20px" }}
                    />
                  </div>
                </Tilt>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* <div className="relative md:pt-8 pb-16 mt-4">
        <div className=" mx-auto w-full">
          <div className="flex flex-wrap">
            <div className="w-full lg:w-6/12 xl:w-3/12 px-4">
              <CardStats
                statSubtitle="Available Balance"
                statTitle={totalBalance.availableBalance}
                currency={currency}
                statPercentColor="text-emerald-500"
                statIconName="fas fa-balance-scale"
                statIconColor="bg-red-500"
              />
            </div>
            <div className="w-full lg:w-6/12 xl:w-3/12 px-4">
              <CardStats
                statSubtitle="Total Credited"
                statTitle={totalBalance.totalCreatedSum}
                currency={currency}
                statPercentColor="text-orange-500"
                statIconName="fas fa-balance-scale"
                statIconColor="bg-orange-500"
              />
            </div>
            <div className="w-full lg:w-6/12 xl:w-3/12 px-4">
              <CardStats
                statSubtitle="Total Debited"
                statTitle={totalBalance.totalDebitedSum}
                currency={currency}
                statPercentColor="text-red-500"
                statIconName="fas fa-balance-scale"
                statIconColor="bg-pink-500"
              />
            </div>
            <div className="w-full lg:w-6/12 xl:w-3/12 px-4">
              <CardStats1
                statSubtitle="Messages"
                statTitle={count.toString()}
                count={count}
                statPercentColor="text-fuchsia-500"
                statIconName="fas fa-balance-scale"
                statIconColor="bg-teal-500"
              />
            </div>
          </div>
        </div>
      </div> */}
    </>
  );
}
